module.exports = __webpack_public_path__ + "img/ebcZh-tw.19deca91.svg";